import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';
// import { Icon, Menu, Accordion } from 'semantic-ui-react';
import { connect } from 'react-redux';
import debug from 'debug';

import styles from './SidebarLowerMenu.styles';
import AccordionTitles from './NavAccordionTitles';
import AccordionContent from './NavAccordionContent';
import SidebarTeamsMenu from './SidebarTeamsMenu';
import MenuType from '../../../../../lib/proptypes/menu.proptypes';
import * as teamsSelectors from '../../../../../store/reducers/teams.selectors';
import { TEAMS_NAV_KEY } from '../../../../../store/actions/nav.types';

const log = debug('huddle:app:nav:mobile:sidebarlowmenu');

const SidebarLowerMenu = ({ menu, teams }) => {
  const Accordions = [];
  if (menu) {
    menu.forEach(item => {
      Accordions.push(AccordionTitles(item));
      item.key === TEAMS_NAV_KEY
        ? Accordions.push(SidebarTeamsMenu(item.key, teams))
        : Accordions.push(AccordionContent(item, teams));
    });
  }

  return (
    <Accordion styled style={styles.accordian}>
      {Accordions}
    </Accordion>
  );
};

SidebarLowerMenu.propTypes = {
  menu: MenuType.isRequired,
  teams: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  menu: state.nav.primary,
  teams: teamsSelectors.selectTeamsHierarchy(state),
});

export default connect(mapStateToProps)(SidebarLowerMenu);



// WEBPACK FOOTER //
// ./src/app/components/Nav/MobileNav/Sidebar/SidebarLowerMenu.js